import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { DashboardService } from 'src/app/services/dashboard.service';
import { IntroductionDetails } from 'src/app/core/enum';
import { AllBaniInfo, Footnotes } from 'src/app/core/models';
import { first } from 'rxjs';
import { StorageService } from 'src/app/services/storage.service';
import {
  AllBaniData,
} from 'src/app/core/models';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-introduction',
  templateUrl: './introduction.component.html',
  styleUrls: ['./introduction.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class IntroductionComponent implements OnInit {
  @ViewChildren('show-footnote-icon') footnoteElements?: QueryList<ElementRef>;
  isHandsetPortrait: boolean = false;
  visible:boolean = false;
  isVisibleShare:boolean = false;
  baniId: string | null = '';
  shareUrl: string | null = '';
  baniInfo?: any = {} as AllBaniInfo;
  baniName?: string;
  introductionParam: string | null = '';
  introductionParamDataPreParsed: string = '';
  introductionParamData: SafeHtml = '';
  previous: string = '';
  next: string = '';
  section: number = 0;
  nextSectionSequence: number = 0;
  fontSize: any = 16;
  isBaniIntroductionParameterLoading: boolean = false;
  allFootnotes: Footnotes[] = [];
  isBaniDataLoading: boolean = false;
  allBaniDashboardData: AllBaniData = {} as AllBaniData;
  buttons: string[] = [];
  isButtonsLoaded: boolean = false;
  allNavigationButtonsList: any[] = []
  allNavigationSectionButtonsListSorted: any[] = []

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dashboardService: DashboardService,
    private sanitizer: DomSanitizer,
    private elementRef: ElementRef,
    private storage: StorageService,
    private renderer: Renderer2,
    private translate: TranslateService
  ) {
    route.params.subscribe(() => {
      this.fetchAndSetBaniData();
    });

    let currentFontSize = localStorage.getItem('fontSize');
    //console.log(currentFontSize);
    if(currentFontSize){
      this.fontSize = currentFontSize;
    }

  }

  ngOnInit(): void {
    this.fetchAndSetBaniData();
    this.shareUrl = location.origin + this.router.url;
  }




  /**
   * request to fetch footnotes by baniId and sectionId
   * section will always be 0 on the Introduction page
   * @param section number = 0
   */
  fetchBaniFootnotes(section: number = 0) {
    this.dashboardService
      .fetchBaniFootnotes(this.baniId, section)
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          if (res?.value?.length) this.allFootnotes = res.value;
          this.setFootnotesData(this.introductionParamDataPreParsed);
        },
        error: (err: any) => {
          console.log('error in fetching bani footnotes');
        },
      });
  }

  /**
   * get params from the url and make requests
   */
  fetchAndSetBaniData(): void {
    this.baniId = this.route.snapshot.paramMap.get('baniId');

    this.introductionParam =
      this.route.snapshot.paramMap.get('introductionParam');

    this.fetchBaniIntroduction(Number(this.baniId));
  }

  setFootnotesData(htmlString: string) {
    let paragraph: any = htmlString.slice();
    let modifiedHTML = htmlString.slice();

    modifiedHTML = modifiedHTML.replace(/\r\n\r/g, '\r\r');
    modifiedHTML = modifiedHTML.replace(/\r/g, '<br>');

    // Extracting values and creating an array of objects
    var tagRegex =
      /<bani:\s*(.*?)\s*&\s*section:\s*(.*?)\s*&\s*footnote:\s*(.*?)>/g;
    var tagObjects = [];
    var match;
    // while ((match = tagRegex.exec(modifiedParagraph)) !== null) {
    while ((match = tagRegex.exec(paragraph)) !== null) {
      var bani = match[1];
      var section = match[2];
      var footnote = match[3];

      let tooltipTextData: any = this.allFootnotes.find((footnoteData) => {
        return (
          footnoteData.SectionId == section &&
          footnoteData.BaniId == this.baniId &&
          footnoteData.FootNoteId == +footnote
        );
      });

      modifiedHTML = modifiedHTML.replace(
        `<bani:${bani} & section:${section} & footnote:${footnote}>`,
        `<div class="tooltip1">  <img alt="Bani Footnote" bani="${bani}" section="${section}" footnote="${footnote}" class=\'show-footnote-icon\' src=\'/assets/images/edit-icon-16.png\' >
        <span class="tooltiptext v">${tooltipTextData?.FootNoteContent}</span>
      </div> `
      );

      tagObjects.push({ bani, section, footnote });
    }

    // Displaying the modified paragraph and the array of objects
    this.introductionParamData =
      this.sanitizer.bypassSecurityTrustHtml(modifiedHTML);
  }

  // -----------------------------------------------------------------------------------------------------------------------------------

  @ViewChild('buttonRow') buttonRowRef!: ElementRef;
  @ViewChild('scrollContainer') scrollContainerRef!: ElementRef;

  activeIndex: number = 0;

  getActiveIndex(): any {
    if (this.introductionParam) {
      this.activeIndex = this.buttons.indexOf(this.introductionParamLabel);
    } else {
      this.activeIndex = 0;
    }
  }
  getButtons() {
    this.buttons = [];
    let baniLanguage = localStorage.getItem('language');
    if (this.baniInfo.Introduction) { this.buttons.push(baniLanguage === 'en' ? 'Introduction' : 'ਜਾਣ-ਪਛਾਣ')}
    if (this.baniInfo.HistoricalDimension) { this.buttons.push(baniLanguage === 'en' ? 'Historical Dimension' : 'ਇਤਿਹਾਸਕ ਪਖ')}
    if (this.baniInfo.MusicalDimension) { this.buttons.push(baniLanguage === 'en' ? 'Musical Dimension' : 'ਸੰਗੀਤਕ ਪਖ');}
    if (this.baniInfo.CulturalDimension) { this.buttons.push(baniLanguage === 'en' ? 'Cultural Dimension' : 'ਸੱਭਿਆਚਾਰਕ ਪਖ');}
    if (this.baniInfo.SignificantTerms) { this.buttons.push(baniLanguage === 'en' ? 'Significant Terms' : 'ਮਹੱਤਵਪੂਰਨ ਨਿਯਮ');}

    console.log('buttons: ', this.buttons);
    this.getActiveIndex();
    this.centerActiveButton();
    this.isButtonsLoaded = true;
    return this.buttons;
  }


  NavigateByBtnTag(btnName: string | number, index: number) {
    console.log('clicked button : ', btnName);
      let baniLanguage = localStorage.getItem('language');
    if(btnName === (baniLanguage === 'en' ? 'Introduction' : 'ਜਾਣ-ਪਛਾਣ')) {
      this.goToIntroduction()
    } else if (btnName === (baniLanguage === 'en' ? 'Historical Dimension' : 'ਇਤਿਹਾਸਕ ਪਖ')){
      this.goToHistoricalDimension();
    } else if (btnName === (baniLanguage === 'en' ? 'Musical Dimension' : 'ਸੰਗੀਤਕ ਪਖ')){
      this.goToMusicalDimension();
    } else if (btnName === (baniLanguage === 'en' ? 'Cultural Dimension' : 'ਸੱਭਿਆਚਾਰਕ ਪਖ')){
      this.goToCulturalDimension();
    } else if (btnName === (baniLanguage === 'en' ? 'Significant Terms' : 'ਮਹੱਤਵਪੂਰਨ ਨਿਯਮ')){
      this.goToSignificantTerms();
    }

    this.setActive(index);
  }

  setActive(index: number) {
    this.activeIndex = index;
    this.centerActiveButton();
  }

  move(direction: number) {
    const newIndex = this.activeIndex + direction;
    if (newIndex >= 0 && newIndex < this.buttons.length) {
      this.setActive(newIndex);
    }
  }

  centerActiveButton() {
    const container = this.scrollContainerRef.nativeElement as HTMLElement;
    const row = this.buttonRowRef.nativeElement as HTMLElement;
    const buttons = row.children;

    if (buttons.length === 0) return;

    const activeBtn = buttons[this.activeIndex] as HTMLElement;
    const containerWidth = container.offsetWidth;
    const btnCenter = activeBtn.offsetLeft + activeBtn.offsetWidth / 2;
    const scrollLeft = btnCenter - containerWidth / 2;

    row.style.transform = `translateX(${-scrollLeft}px)`;
  }

  // -----------------------------------------------------------------------------------------------------------------------------------

  /* removeAllOtherTooltips() {
    const elements =
      this.elementRef.nativeElement.querySelectorAll('.is-visible');

    elements.forEach((element: any) => {
      this.renderer.removeClass(element, 'is-visible');
    });
  }

  @HostListener('document:click', ['$event.target'])
  onClick(target: HTMLElement) {
    // Check if the clicked element is a parent element
    if (target.classList.contains('show-footnote-icon')) {
      // Find the child element within the parent
      // const childElement = target.querySelector('.tooltiptext');
      const parentElement = target.parentElement;

      const childElement = parentElement?.querySelector('.tooltiptext');
      // Toggle the class on the child element
      if (childElement) {
        this.removeAllOtherTooltips();
        this.renderer.addClass(childElement, 'is-visible');
        const leftPos = target.getBoundingClientRect().left;
       const tooltipWidth = 240 // tootltip width is 240px
       const innerWidth = window.innerWidth > 1280 ? 1280 : window.innerWidth;
       if(leftPos + tooltipWidth > innerWidth){
        let right = '0px'
       if(tooltipWidth > leftPos){
        right = `${leftPos -tooltipWidth}px`
       }
        this.renderer.setStyle(childElement,'right',right)
       }
       else{
        this.renderer.removeStyle(childElement,'right');
       }
      }
    } else {
      // Remove the class from all child elements
      const childElements =
        this.elementRef.nativeElement.querySelectorAll('.tooltiptext');
      childElements.forEach((childElement: any) => {
        this.renderer.removeClass(childElement, 'is-visible');
      });
    }
  } */
removeAllOtherTooltips() {
  const elements = this.elementRef.nativeElement.querySelectorAll('.tooltiptext');
  elements.forEach((el: HTMLElement) => {
    this.renderer.removeClass(el, 'is-visible');
    this.renderer.removeStyle(el, 'left');
    this.renderer.removeStyle(el, 'right');
    this.renderer.removeStyle(el, 'top');
    this.renderer.removeStyle(el, 'bottom');

    this.renderer.removeStyle(el, 'opacity');
    this.renderer.removeStyle(el, 'visibility');
  });
}

@HostListener('document:click', ['$event'])
onClick(event: MouseEvent) {
  const target = event.target as HTMLElement;

  if (target.classList.contains('show-footnote-icon')) {

    const parent = target.parentElement;
    const tooltip = parent?.querySelector('.tooltiptext') as HTMLElement;
    if (!tooltip) return;

    this.removeAllOtherTooltips();

    // Prepare to measure
    this.renderer.addClass(tooltip, "is-visible");
    this.renderer.setStyle(tooltip, "opacity", "0");
    this.renderer.setStyle(tooltip, "visibility", "hidden");

    setTimeout(() => {
      const iconRect = target.getBoundingClientRect();
      const tipRect = tooltip.getBoundingClientRect();

      const screenWidth = Math.min(window.innerWidth, 1280);
      const screenLeft = (window.innerWidth - screenWidth) / 2;
      const screenRight = screenLeft + screenWidth;

      /** RESET */
      this.renderer.removeStyle(tooltip, "top");
      this.renderer.removeStyle(tooltip, "left");

      /* -----------------------------------
         HORIZONTAL POSITION (FIXED)
      ----------------------------------- */

      let left = iconRect.left;

      // Ensure tooltip stays inside the 1280px main view
      if (left + tipRect.width > screenRight) {
        left = screenRight - tipRect.width - 10;
      }
      if (left < screenLeft) {
        left = screenLeft + 10;
      }

      /* -----------------------------------
         VERTICAL POSITION (FIXED)
      ----------------------------------- */

      let top = iconRect.bottom + 10;

      if (top + tipRect.height > window.innerHeight) {
        // show above
        top = iconRect.top - tipRect.height - 10;
      }

      // If still doesn't fit → center vertically
      if (top < 0 || top + tipRect.height > window.innerHeight) {
        top = (window.innerHeight - tipRect.height) / 2;
      }

      // Apply
      this.renderer.setStyle(tooltip, "left", `${ screenWidth < 599.98 ? 60 : left }px`);
      this.renderer.setStyle(tooltip, "top", `${top}px`);

      // Show tooltip
      this.renderer.setStyle(tooltip, "opacity", "1");
      this.renderer.setStyle(tooltip, "visibility", "visible");

    }, 15);

    return;
  }

  // If clicked inside tooltip → DO NOT CLOSE
  if (target.closest(".tooltiptext")) return;

  this.removeAllOtherTooltips();
}



  /**
   * request to fetch introduction data by BaniID
   * @param baniId number
   */
  fetchBaniIntroduction(baniId: number): void {
    this.isBaniIntroductionParameterLoading = true;
    this.dashboardService
      .fetchBaniIntroductionData(baniId)
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          if (res?.value?.length) {
            this.isBaniIntroductionParameterLoading = false;
            this.baniInfo = res.value[0];
            this.getButtons()
            if(this.activeIndex === 0){
              this.move(1);
              this.move(-1);
            }
            // this.isButtonsLoaded = true;

            this.setPreviousAndNextLinks();

            if (this.introductionParam) {
              this.introductionParamDataPreParsed =
                this.baniInfo[this.introductionParam];
            }

            this.fetchBaniFootnotes();
            this.fetchBaniDashboardData(this.baniInfo.BaniCode);
          }
        },
        error: () => {
          console.log('error in fetching bani introduction');
        },
      });
  }

  // check if it exists in the object
  // then provide the corresponding label
  setPreviousAndNextLinks(): void {
    switch (this.introductionParam) {
      case IntroductionDetails.Introduction:
        this.previous = '';
        this.next = this.baniInfo.HistoricalDimension
          ? IntroductionDetails.HistoricalDimension
          : this.baniInfo.MusicalDimension
          ? IntroductionDetails.MusicalDimension
          : this.baniInfo.CulturalDimension
          ? IntroductionDetails.CulturalDimension
          : '';
        break;

      case IntroductionDetails.HistoricalDimension:
        this.previous = this.baniInfo.Introduction
          ? IntroductionDetails.Introduction
          : '';
        this.next = this.baniInfo.MusicalDimension
          ? IntroductionDetails.MusicalDimension
          : false || this.baniInfo.CulturalDimension
          ? IntroductionDetails.CulturalDimension
          : '';
        break;

      case IntroductionDetails.MusicalDimension:
        this.previous = this.baniInfo.HistoricalDimension
          ? IntroductionDetails.HistoricalDimension
          : '';
        this.next = this.baniInfo.CulturalDimension
          ? IntroductionDetails.CulturalDimension
          : false || this.baniInfo.SignificantTerms
          ? IntroductionDetails.SignificantTerms
          : '';
        break;

      case IntroductionDetails.CulturalDimension:
        this.previous = IntroductionDetails.MusicalDimension;
        this.next = '';
        break;

      case IntroductionDetails.SignificantTerms:
        this.previous = IntroductionDetails.MusicalDimension;
        this.next = '';
        break;
    }
  }

  handlePrevious(): void {
    window.scrollTo(0, 0);
    if (this.previous)
      this.router.navigate(['/bani/introduction/', this.baniId, this.previous]);
  }

  handleNext(): void {
    window.scrollTo(0, 0);
    //console.log(this.next);
    if (this.next){
      this.router.navigate(['/bani/introduction/', this.baniId, this.next]);
    }else{
      this.router.navigate(['/bani/details/', this.baniInfo.BaniCode,this.nextSectionSequence,2]);
    }
  }

  goToIntroduction(): void {
    this.router.navigate([
      '/bani/introduction/',
      this.baniId,
      IntroductionDetails.Introduction,
    ]);
  }

  goToBani(): void {
    this.router.navigate(['/bani', this.baniInfo.BaniCode]);
  }

  goToHistoricalDimension(): void {
    this.router.navigate([
      '/bani/introduction/',
      this.baniId,
      IntroductionDetails.HistoricalDimension,
    ]);
  }

  goToMusicalDimension(): void {
    this.router.navigate([
      '/bani/introduction/',
      this.baniId,
      IntroductionDetails.MusicalDimension,
    ]);
  }

  goToCulturalDimension(): void {
    this.router.navigate([
      '/bani/introduction/',
      this.baniId,
      IntroductionDetails.CulturalDimension,
    ]);
  }

  goToSignificantTerms(): void {
    this.router.navigate([
      '/bani/introduction/',
      this.baniId,
      IntroductionDetails.SignificantTerms,
    ]);
  }

  /**
   * Gets introduction param label
   * TODO: make i18n method for labels
   */
  get introductionParamLabel() {
    let stringLabel = '';
    let baniLanguage = localStorage.getItem('language');
    switch (this.introductionParam) {
      case IntroductionDetails.Introduction:
        stringLabel = baniLanguage === 'en' ? 'Introduction' : 'ਜਾਣ-ਪਛਾਣ';
        break;
      case IntroductionDetails.HistoricalDimension:
        stringLabel =
          baniLanguage === 'en' ? 'Historical Dimension' : 'ਇਤਿਹਾਸਕ ਪਖ';
        break;
      case IntroductionDetails.CulturalDimension:
        stringLabel =
          baniLanguage === 'en' ? 'Cultural Dimension' : 'Cultural Dimension';
        break;
      case IntroductionDetails.MusicalDimension:
        stringLabel = baniLanguage === 'en' ? 'Musical Dimension' : 'ਸੰਗੀਤਕ ਪਖ';
        break;
      case IntroductionDetails.SignificantTerms:
        stringLabel = baniLanguage === 'en' ? 'Significant Terms' : 'ਮਹੱਤਵਪੂਰਨ ਨਿਯਮ';
        break;  
    }
    return stringLabel;
  }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }

  handleIconClick(
    event: any,
    bani: number,
    section: number,
    footnote: number
  ) {}

  showFontList(){

    this.isVisibleShare = false;
    if(this.visible == true){

      this.visible = false;

    }else{

      this.visible = true;

    }
  }
  showShareList(){

    this.visible = false;
    if(this.isVisibleShare == true){

      this.isVisibleShare = false;

    }else{

      this.isVisibleShare = true;

    }
  }

  setFont(size:any){
    
    this.storage.set('fontSize', size);
    this.fontSize = size;
    this.visible = false;
  }

  getBackgroundImageUrl(img:string): any{
      //img= typeof img === 'string' ? img.trim() : '';
      img = img?.trim() || '';
      if(img != ''){
        return `url('${img}')`;
      }else{
        let imgUrl = '/assets/images/carousel-background.webp';
        return `url(${imgUrl})`;
      } 
    
  }

    //Get next page details for navigation
  fetchBaniDashboardData(baniCode: string | null) {
    //console.log(baniCode);
    this.isBaniDataLoading = true;
    this.dashboardService
      .fetchBaniDashboardData(baniCode)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.isBaniDataLoading = false;
          this.allBaniDashboardData = res?.value?.length ? res.value[0] : {};

          // sort sections in descreasing increasing order by SectionSequence
          this.allBaniDashboardData.Sections =
            this.allBaniDashboardData.Sections.sort(
              (a: any, b: any) =>
                parseFloat(a.SectionSequence) - parseFloat(b.SectionSequence)
            );

            this.nextSectionSequence = this.allBaniDashboardData.Sections[0].SectionSequence;

            // console.log(this.nextSectionSequence);
          //this.baniIntroduction = this.allBaniDashboardData.Introduction;
        },
        error: (err) => {
          console.log('error in fetching bani dashboard data ', err);
        },
      });

      this.dashboardService
      .fetchBaniSubDetails(baniCode, 1, 2)
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          let data = res?.value?.length ? res.value[0] : null;
          if (!data) return;

          // Extract only what you need
          this.allNavigationButtonsList = [];
          this.allNavigationButtonsList.push({
            type: 'introDetail',
            RowID: data.RowID,
            BaniCode: data.BaniCode,
            BaniId: data.BaniId,
            BaniSequence: data.BaniSequence,
            BaniName: data.BaniName,

            Introduction: !!data.Introduction,
            HistoricalDimension: !!data.HistoricalDimension,
            MusicalDimension: !!data.MusicalDimension,
            CulturalDimension: !!data.CulturalDimension,
            SignificantTerms: !!data.SignificantTerms,

            NavBaniName: data.NavBaniName,
            IsIntroduction: data.IsIntroduction,

            Sections: data?.Sections?.map((Section: any) => ({
              type: 'section',
              SectionId: Section.SectionId,
              SectionName: Section.SectionName,
              SectionSequence: Section.SectionSequence,
              NavSectionName: Section.NavSectionName,
              PageNumberStart: Section.PageNumberStart,

              SubSection: Section?.SubSection?.map((sub: any) => ({
                type: 'subsection',
                SubSectionId: sub.SubSectionId,
                SubSectionName: sub.SubSectionName,
                SectionName: sub.SectionName,
                SubSectionSequence: sub.SubSectionSequence
              })) || []
            })) || []
          });
          this.allNavigationSectionButtonsListSorted = [];
          this.allNavigationSectionButtonsListSorted = this.allNavigationButtonsList[0].Sections.sort(
            (a: any, b: any) =>
              parseFloat(a.SectionSequence) - parseFloat(b.SectionSequence)
          );
          console.log("Navigation Buttons:", this.allNavigationButtonsList);
        },
        error: (err: any) => {}
      });
    }
    navigateOnDetailPage(sectionName: string){
      let section = this.allNavigationButtonsList[0].Sections.find((sec: any) => sec.SectionName === sectionName);
      if(section){
        this.router.navigate(['/bani/details/', this.baniInfo.BaniCode, section.SectionSequence, 2]);
      }
    }
    fetchLanguage(): string | null {
      return this.storage.get('language');
    }
}
